(() => {
  class ChangeStoreOrderController {
    constructor($rootScope, $scope, $timeout, $interval, Users, Orders, toastr, $state, ngDialog) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        Users,
        Orders,
        toastr,
        $state,
        ngDialog,
        stores: [],
        selectedStore: [],
        store_id: null,
        saveEnabled: false
      });
      $scope.$on('ngDialog.opened', function (e, $dialog) {
        $(".ngdialog-theme-default.ngdialog").children(".ngdialog-content").draggable({
          handle: ".mailorder-cancellation-popup-handler"
        });
      }); // Default Value for Radio Option

      this.getStores();
      this.status = 'cancelled';
      this.options = [{
        id: '1',
        name: 'User cancelled',
        value: 'cancelled'
      }];
      this.$timeout(function () {
        $("button.md-datepicker-button").css("margin-left", "34px");
        $("input.md-datepicker-input").css("background-color", "#EEEFF2");
      }, 100);
    }

    getStores() {
      this.Orders.getStores().then(({
        data
      }) => {
        this.stores = data;
      });
    }

    setStore(data) {
      this.store_id = data.id;
    }

    save() {
      var response = {
        pharmacy_id: this.store_id
      };
      this.$scope.closeThisDialog(response);
    }

  }

  ChangeStoreOrderController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "Users", "Orders", "toastr", "$state", "ngDialog"];
  angular.module('pims').controller('ChangeStoreOrderController', ChangeStoreOrderController);
})();